export interface ToggleTabSpec<T extends string> {
  id: T;
  label: string;
}

interface Props<T extends string> {
  tabs: ToggleTabSpec<T>[];
  active: T;
  onChange: (id: T) => void;
}

export function ToggleTabs<T extends string>({ tabs, active, onChange }: Props<T>) {
  return (
    <div className="inline-flex rounded-lg border border-white/10 bg-indra-azul-deep p-1 gap-1">
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => onChange(t.id)}
          className={
            "px-3 py-1.5 text-xs font-medium rounded-md transition-colors " +
            (active === t.id
              ? "bg-indra-turquesa text-indra-azul"
              : "text-white/60 hover:text-white")
          }
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
